export default __webpack_public_path__ + "static/media/item_5.4116118f.png";